import axios from 'axios';

export const getUserInfos = async () => {
    return await axios.get(`/Home/GetUserInfo`);
}

export const setCulture = async (lang?: string) => {
    return await axios.post(`/Culture/SetCulture?culture=${lang}`);
}